import { api } from '../../services/apiClient';

export interface ScheduleBlock {
  weekday: number; start_time: string; end_time: string;
  class_id: number; name: string; color: string | null; classroom?: string | null;
}
export interface MyEvent {
  event_id: number; name: string; datetime: string | null; venue: string | null;
  image_url: string | null; event_type: string | null; event_type_color: string | null;
}
export interface Overview {
  profile: { account_id: number; firstname: string; lastname: string; dob: string | null;
    has_photo: number; membership_name: string | null; membership_color: string | null };
  schedule: ScheduleBlock[];
  debt: { count: number; total: number };
  events: MyEvent[];
  counts: { classes: number; payments: number };
}
export interface MyClass {
  class_id: number; name: string; color: string | null; style: string | null; teacher: string | null;
  schedule: { weekday: number; start_time: string; end_time: string }[];
}
export interface MyPayment {
  payment_id: number; pay_date: string | null; type: string; method: string;
  amount: string; assoc_name: string | null; months: string | null;
}
export interface MyAttendance { status: string; date: string; class_name: string; color: string | null; }

export interface TeachingClass {
  class_id: number; name: string; color: string | null; style: string | null;
  capacity: number | null; enrolled: number;
  schedule: { weekday: number; start_time: string; end_time: string }[];
}
export function getTeaching() { return api.get<{ data: TeachingClass[] }>('/me/teaching'); }

// Catálogo: TODAS las clases ofertadas (con marca de si ya estoy inscrito)
export interface CatalogClass {
  class_id: number; name: string; color: string | null; capacity: number | null; image_url: string | null;
  style: string | null; teacher: string | null; enrolled: number; enrolled_me: boolean;
  schedule: { weekday: number; start_time: string; end_time: string }[];
}
export function getCatalog() { return api.get<{ data: CatalogClass[] }>('/me/catalog'); }

// Eventos del estudio visibles al alumno
export interface MyEventFull {
  event_id: number; name: string; description: string | null; datetime: string | null;
  venue: string | null; venue_address: string | null; price: string | null;
  image_url: string | null; event_type: string | null; event_type_color: string | null; going: boolean;
}
export function getMyEvents() { return api.get<{ data: MyEventFull[] }>('/me/events'); }

export function getOverview() { return api.get<Overview>('/me/overview'); }
export function getMyClasses() { return api.get<{ data: MyClass[] }>('/me/classes'); }
export function getMyPayments() { return api.get<{ data: MyPayment[]; total: number; count: number }>('/me/payments'); }
export function getMyAttendance() { return api.get<{ data: MyAttendance[] }>('/me/attendance'); }

// Mensajería interna con el estudio (Sección 6 / Módulo A) — lado alumno
export interface MyMessage { message_id: number; sender_role: 'staff' | 'student'; body: string; created_at: string; }
export function getMyMessages() { return api.get<{ data: MyMessage[] }>('/me/messages'); }
export function getMyMessagesUnread() { return api.get<{ unread: number }>('/me/messages/unread'); }
export function sendMyMessage(body: string) { return api.post<{ ok: true; message_id: number }>('/me/messages', { body }); }

export const WEEKDAYS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
export const WEEKDAYS_SHORT = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];

export function hhmm(t: string) { return (t || '').slice(0, 5); }
// Acepta null/undefined: los importes DECIMAL llegan del API como `string | null`.
export function money(n: number | string | null | undefined) {
  return '$' + Number(n || 0).toLocaleString('es-MX', { maximumFractionDigits: 0 });
}
// 🚨 17-sep-2026: estas etiquetas divergían de las de la consola (features/finances/api.ts), así
// que el MISMO pago se llamaba «Licencia» en el portal del alumno e «Inscripción» en recepción.
// Se igualan a las de la consola, que son las palabras que usa el estudio.
export const TYPE_LABEL: Record<string, string> = {
  membership: 'Mensualidad', event: 'Evento', other: 'Otro pago', license: 'Inscripción',
  voucher_trial: 'Clase de prueba', voucher: 'Bono de clases', voucher_voucher: 'Bono de clases',
  class: 'Clase suelta', product: 'Vitrina', refund: 'Devolución',
};
export const METHOD_LABEL: Record<string, string> = { cash: 'Efectivo', creditcard: 'Tarjeta', wire: 'Transferencia' };
